import { IPerfectScrollState } from "../scroll/perfectScrollModel";

export const horizontalBarStateSelector = (s: IPerfectScrollState) => ({
    scrollbarXActive: s.status?.scrollbarXActive,
    maxScrollbarLength: s.options?.maxScrollbarLength,
    minScrollbarLength: s.options?.minScrollbarLength,
    containerWidth: s.horizontalDimension?.containerMeasure,
    contentWidth: s.horizontalDimension?.contentMeasure,
    scrollLeft: Math.floor(s.horizontalDimension?.scrollMeasure),
    negativeScrollAdjustment: s.status?.negativeScrollAdjustment,
});
